import { Component, Input } from '@angular/core';
import { ISettings } from 'app/_models/ISettings';
import { IconDefinition, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'image-viewer-component',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.css']
})
export class ImageViewerComponent {
  //#region Fields & Icons
  @Input() image: any;
  @Input() settings: ISettings;
  zoom: number = 1;
  zoomStep: number = 0.1;
  maxZoom: number = 3;
  minZoom: number = 1;
  transformOrigin: string = 'center center';
  isPanning: boolean = false;
  startX: number = 0;
  startY: number = 0;
  translateX: number = 0;
  translateY: number = 0;
  faPlus: IconDefinition = faPlus;  
  faMinus: IconDefinition = faMinus;
  //#endregion

  constructor() { }

  zoomIn(): void {
    if (this.zoom < this.maxZoom) this.zoom += this.zoomStep;          
  }

  zoomOut(): void {
    if (this.zoom > this.minZoom) {
      this.zoom -= this.zoomStep;      
      if (this.zoom === this.minZoom) {
        this.translateX = 0;
        this.translateY = 0;
      }
    }
  }

  onWheel(event: WheelEvent): void {
    event.preventDefault();   
    let container = (event.target as HTMLElement).closest('.image-container');
    if (!container) return;

    let rect = container.getBoundingClientRect();
    let offsetX = event.clientX - rect.left;
    let offsetY = event.clientY - rect.top;    
    this.transformOrigin = `${offsetX}px ${offsetY}px`;
    
    if (event.deltaY < 0) this.zoomIn(); 
    else this.zoomOut();
  }

  startPan(event: MouseEvent): void {
    if (this.zoom <= 1) return;
    this.isPanning = true;
    this.startX = event.clientX - this.translateX;
    this.startY = event.clientY - this.translateY;
  }

  onPan(event: MouseEvent): void {
    if (!this.isPanning) return;
    this.translateX = event.clientX - this.startX;
    this.translateY = event.clientY - this.startY;
  }

  endPan(): void {
    this.isPanning = false;
  }
}